import React from 'react';
import PropTypes from 'prop-types';
import { SpanWrapper } from './styles';

const Value = ({ children, disabled = false }) => (
  <SpanWrapper disabled={disabled}>
    <span className="custom select">{children}</span>
  </SpanWrapper>
);

Value.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]).isRequired,
  disabled: PropTypes.bool,
};

export default Value;
